// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useEffect} from 'react';
import {use_pathname} from '../../../../hola/pub/lib/use_pathname';
import country from '/util/country.js';
import {Location_hero} from '../../ui/location/hero';
import {Top_locations} from '../../ui/location/top_locations';
import {HP_cards} from '../../ui/hp_cards';
import {Products_cards} from '../../ui/free_proxy/product_cards';
import {Use_case_bubbles} from '../../ui/use_case_bubbles';
import {Review_slides} from '../../ui/landings/review_slides';
import {Faq_section} from '../../ui/toolip/faq_section';
import {prepare_continent_data} from '../../ui/location/top_locations';
import {use_show_promo} from '../../ui/free_proxy/use_show_promo';
import {perr_www_visit} from 'hola_pub_util';
import cn from 'classnames';
import {Button} from '../../../../hola/pub/lib/button';
import Arrow_right from '../../../../hola/pub/img/hola2023/icons/24/arrow_right.svg';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import styles from './proxy-location.module.less';

export const Root = ()=>{
    const {theme} = React.useContext(Settings_context);
    const {T} = use_translation_v({no_defaults: true});
    const {set, params} = use_pathname();
    const {show_promo, get_cta} = use_show_promo();
    const location_name = params['proxy-location'];
    const us_region_name = params['united-states'];
    const detected_location_name = !location_name && us_region_name
        ? 'united-states' : location_name;
    const is_lobby_page =
        !detected_location_name || detected_location_name === '';
    const caption = show_promo ? 'Try now for free' : 'Try now';
    useEffect(()=>{
        if (location_name?.length == 2)
        {
            const normalized_name = location_name.toUpperCase();
            const c = Object.entries(country.list).find(([key])=>
                key == normalized_name);
            if (c && typeof c[1] == 'string')
            {
                const country_param = c[1] == 'United Kingdom' ?
                    'great-britain' : c[1].toLowerCase().replace(/\s+/g, '-');
                set({
                    'proxy-location': country_param
                });
            }
        }
    }, [location_name, set]);
    useEffect(()=>{
        perr_www_visit({id: 'toolip_proxy_location_visit'});
    }, []);
    return <div>
      <Location_hero country={detected_location_name}
        region={us_region_name}/>
      <Top_locations country={detected_location_name}/>
      <HP_cards/>
      {!is_lobby_page && <Use_case_bubbles offset_top={-390}/>}
      <Products_cards
        title='The toolip Products'
        subtitle={'Choose what best matches your needs and goals on '+
          'the house!'}
        with_icons
        get_cta={get_cta}
      />
      {!is_lobby_page && <Review_slides/>}
      <div className={cn(styles.faq_block, theme.container)}>
        <Faq_section
          title={is_lobby_page
            ? 'When we say our proxies are global, we mean it.'
            : 'Some FAQs'}
          color={'transparent'}
          custom_questions={is_lobby_page
            ? prepare_continent_data()
            : undefined}
        />
      </div>
      <div className={styles.final}>
        <div className={styles.final_bg}/>
        <div className={styles.final_container}>
          <h2><T>Get the right Proxies</T>.<br/>
            <T>Get ahead</T>.</h2>
          <Button size={'lg'} no_jump cls={styles.final_btn}
            to={'/dashboard'} fit round={false}
            caption={<React.Fragment><T>{caption}</T> <Arrow_right/>
            </React.Fragment>}/>
        </div>
      </div>
    </div>;
};

const meta = {
    meta: props=>{
        const {translate = t=>t} = props;
        const param = props?.params?.['proxy-location'] || '';
        const us_region = props?.params?.['united-states'];
        const location = param || us_region || '';
        let title, description, canonical_url;
        if (!location)
        {
            title = translate('Real Proxy IP Servers in Any Location');
            description = translate('Uncover the advantages of real proxy'+
             ' ip servers in any location.');
            canonical_url = 'https://toolip.io/proxy-location/';
        }
        else
        {
            const countryName = param.replace(/-/g, ' ')
                .replace(/\b\w/g, c=>c.toUpperCase());
            title = translate(`Premium ${countryName} Proxies - Try Now For
                Free | Toolip`);
            description = translate(`Unlock ${countryName} proxies with a
                free trial. Experience premium connectivity now.`);
            canonical_url = `https://toolip.io/proxy-location/${param}`;
        }
        return {title, description, canonical_url};
    },
    no_ssr: false,
    ssr_force: true,
    footer_opt: {
        gradient_color: 'var(--wp--preset--color--blue-100)',
    },
    translation: {
        enabled: true,
        detect_by_country: true,
        white_list: ['en', 'ru', 'es', 'tr', 'de', 'fr', 'ja', 'he', 'zh']
    },
};
Root.meta = meta;

